/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%;display:block;background:#fff;padding:16px 24px;border-bottom:1px solid rgba(0,0,0,.12)}button[_ngcontent-%COMP%]{display:none}"];
export { styles as styles };
